import { useEffect } from 'react';
import { useLocation } from 'react-router';
import Navbar from '@components/landing/Navbar';
import Feedback from '@components/landing/Feedback';
import Footer from '@components/landing/Footer';
import ScrollToTop from '@components/ScrollToTop';

/**
 * Common chrome for every interior page: navbar, the feedback band, footer and
 * the back-to-top control, plus a scroll reset whenever the route changes.
 */
export default function PageShell({ children }: { children: React.ReactNode }) {
    const { pathname } = useLocation();

    useEffect(() => {
        document.querySelector('.page-scroll-root')?.scrollTo({ top: 0 });
    }, [pathname]);

    return (
        <div className="page-scroll-root bg-white">
            <Navbar solid />
            <main className="w-full">{children}</main>
            <Feedback />
            <Footer />
            <ScrollToTop />
        </div>
    );
}
